/*
 * Textseiten (sections/kik-seite.liquid): Bilder im Seitentext stehen im Admin oft untereinander
 * (<p><img></p><p><img></p> … oder mehrere <img> in einem <div>). Dieses Skript fasst zwei oder mehr direkt
 * aufeinanderfolgende Bild-Absätze bzw. einen Absatz mit mehreren Bildern zu einem 2er-Raster zusammen. Einzelne Bilder
 * bleiben, wie sie sind, und werden auf Spaltenbreite gezogen (kik-base.css). Leere Absätze (nur &nbsp;) als
 * Abstandshalter fallen weg. Der Seitentext im Admin wird nicht verändert, nur die Darstellung.
 */
(() => {
  const ohneText = (el) => el.textContent.replace(/\s| /g, '') === '';

  const bildAnzahl = (el) => {
    if (!el || el.nodeType !== 1) return 0;
    if (el.tagName === 'IMG' || el.tagName === 'FIGURE') return 1;
    if (!['P', 'DIV', 'SPAN', 'A'].includes(el.tagName) || !ohneText(el)) return 0;
    return el.querySelectorAll('img').length;
  };

  document.querySelectorAll('[data-kik-prose]').forEach((prose) => {
    let gruppe = [];
    const abschliessen = () => {
      if (gruppe.length >= 2) {
        const raster = document.createElement('div');
        raster.className = 'kik-bildraster';
        gruppe[0].before(raster);
        gruppe.forEach((el) => raster.appendChild(el));
      }
      gruppe = [];
    };

    [...prose.children].forEach((el) => {
      const bilder = bildAnzahl(el);
      if (bilder > 1) {
        abschliessen();
        el.classList.add('kik-bildraster');
      } else if (bilder === 1) {
        gruppe.push(el);
      } else if (el.tagName === 'P' && ohneText(el) && !el.querySelector('img, iframe, video')) {
        el.remove();
      } else {
        abschliessen();
      }
    });
    abschliessen();
  });
})();
